import React from 'react';
import { Building2 } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth-store';

export const ProfileSocietyCard: React.FC = () => {
  const { society } = useAuthStore();

  if (!society) {
    return null;
  }

  const societyInitials = society.name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-200 tw-p-6">
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-6">
        <Building2 className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
        <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
          Société
        </h2>
      </div>

      <div className="tw-flex tw-items-start tw-gap-6">
        {/* Logo ou Avatar */}
        {society.logo ? (
          <div className="tw-w-20 tw-h-20 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-bg-gray-100 tw-flex-shrink-0">
            <img
              src={society.logo}
              alt={society.name}
              className="tw-w-full tw-h-full tw-object-cover"
            />
          </div>
        ) : (
          <div className="tw-w-20 tw-h-20 tw-bg-gradient-to-br tw-from-affinicar-primary tw-to-affinicar-secondary tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-text-2xl tw-font-semibold tw-flex-shrink-0">
            {societyInitials}
          </div>
        )}

        {/* Infos */}
        <div className="tw-flex-1 tw-space-y-4">
          {/* Ligne 1: Nom de la société + Email + Téléphone */}
          <div className="tw-grid tw-grid-cols-3 tw-gap-4">
            <div>
              <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                Nom de la société
              </label>
              <p className="tw-text-sm tw-font-medium tw-text-gray-900">
                {society.name}
              </p>
            </div>

            <div>
              <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                Email
              </label>
              <p className="tw-text-sm tw-text-gray-900">
                {society.email || 'Non renseigné'}
              </p>
            </div>

            <div>
              <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                Téléphone
              </label>
              <p className="tw-text-sm tw-text-gray-900">
                {society.phone || 'Non renseigné'}
              </p>
            </div>
          </div>

          {/* Ligne 2: Adresse */}
          {society.address && (
            <div>
              <label className="tw-block tw-text-xs tw-font-medium tw-text-gray-500 tw-mb-1">
                Adresse
              </label>
              <p className="tw-text-sm tw-text-gray-900">
                {society.address}
                {society.postalCode && society.city && (
                  <>, {society.postalCode} {society.city}</>
                )}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
